import React from "react";
import { EmptyLow, HeaderContainer, LabelContainer, ListContainer } from "./DeviceAlarmManagerList.styles";
import UI from "@mile-meeting/mile-ui";

import { IReceiverMember } from "pages/meeting/complain-manager-setting/uis/table-view/person-table-view";
import DeviceAlarmManagerListItem from "./DeviceAlarmManagerListItem";

export type DeviceAlarmManagerListProps = {
  onHandleDeleteManager: (mediumId: string, name: string) => Promise<void>;
  managerList: IReceiverMember[];
};

const DeviceAlarmManagerList: React.FC<DeviceAlarmManagerListProps> = ({ managerList, onHandleDeleteManager }) => {
  return (
    <ListContainer>
      <HeaderContainer>
        <LabelContainer minWidth={160} maxWidth={200}>
          <UI.Typography type="label01" color="var(--alias-color-label-normal)">
            이름
          </UI.Typography>
        </LabelContainer>
        <LabelContainer minWidth={200} maxWidth={240}>
          <UI.Typography type="label01" color="var(--alias-color-label-normal)">
            이메일
          </UI.Typography>
        </LabelContainer>
        <LabelContainer
          minWidth={74}
          maxWidth={160}
          style={{
            marginLeft: "auto",
          }}
        >
          <UI.Typography type="label01" color="var(--alias-color-label-normal)">
            관리
          </UI.Typography>
        </LabelContainer>
      </HeaderContainer>
      {managerList.length === 0 && (
        <EmptyLow>
          <UI.Icon name="addPerson" color="var(--alias-color-label-alternative)" size={24} />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            등록된 담당자가 없습니다. 신속한 조치를 위해 담당자를 추가해 주세요.
          </UI.Typography>
        </EmptyLow>
      )}
      {managerList.map((manager) => (
        <DeviceAlarmManagerListItem
          name={manager.host.nickname}
          email={manager.host.email}
          image={manager.host.image}
          onDelete={() => {
            onHandleDeleteManager(manager.id, manager.host.nickname);
          }}
        />
      ))}
    </ListContainer>
  );
};

export default React.memo(DeviceAlarmManagerList);
